<div class="mx-auto w-full h-full justify-center space-y-6 sm:w-96">
  <div class="space-y-2 text-center">
    <h1 class="text-2xl font-semibold tracking-tight">Password dimenticata</h1>
    <p class="text-muted-foreground text-sm">
      @if (
        forgotPasswordState() === forgotPasswordEnum.INPUT_VERIFICATION_CODE
      ) {
        Abbiamo inviato un codice di verifica a
        {{ emailForm.controls.email.value | maskEmail }}
      } @else if (forgotPasswordState() === forgotPasswordEnum.SUCCESS) {
        Password reimpostata con successo!
      } @else if (forgotPasswordState() === forgotPasswordEnum.FAIL) {
        Si è verificato un errore. Riprova più tardi.
      } @else {
        Inserisci la tua email per reimpostare la password
      }
    </p>
  </div>

  <div class="grid">
    @if (forgotPasswordState() === undefined) {
      <form [formGroup]="emailForm" (ngSubmit)="sendCodeResetPassword()">
        @if (errorMessage()) {
          <p class="text-destructive text-sm text-center mb-4">
            {{ errorMessage() }}
          </p>
        }
        <div class="space-y-2">
          <label hlmLabel>Email</label>
          <input
            hlmInput
            class="w-full"
            type="email"
            id="email"
            formControlName="email"
            placeholder="nome@esempio.com"
            autocomplete="off"
          />
        </div>

        <button hlmBtn [disabled]="isLoading()" class="mt-4 w-full">
          @if (isLoading()) {
            <hlm-spinner class="mr-2" />
          }
          Invia codice
        </button>

        <button
          hlmBtn
          variant="link"
          class="mt-4 w-full"
          [disabled]="isLoading()"
          (click)="onSignInClick()"
          type="button"
        >
          Torna al login
        </button>
      </form>
    } @else if (
      forgotPasswordState() === forgotPasswordEnum.INPUT_VERIFICATION_CODE
    ) {
      <form
        [formGroup]="forgotPasswordForm"
        (ngSubmit)="confirmNewPassword()"
        class="flex flex-col gap-2"
      >
        @if (errorMessage()) {
          <p class="text-destructive text-sm text-center mb-2">
            {{ errorMessage() }}
          </p>
        }
        <div class="space-y-2">
          <label hlmLabel> Codice di verifica </label>
          <input
            hlmInput
            class="w-full"
            type="text"
            id="code"
            formControlName="code"
            placeholder="Inserisci il codice"
            autocomplete="off"
          />
        </div>

        <div class="space-y-2">
          <label hlmLabel> Nuova password </label>
          <o2-password-input
            class="w-full"
            id="password"
            formControlName="password"
            placeholder="Inserisci nuova password"
          />
        </div>

        <div class="space-y-2">
          <label hlmLabel> Conferma password </label>
          <o2-password-input
            class="w-full"
            id="confirmPassword"
            formControlName="confirmPassword"
            placeholder="Conferma password"
          />
        </div>

        <!-- Password requirements checklist -->
        <div class="text-sm space-y-1">
          <p class="text-muted-foreground font-medium mb-2">
            La password deve contenere:
          </p>
          <div
            class="flex items-center gap-2"
            [class.text-green-600]="passwordValidation.minLength"
            [class.text-muted-foreground]="!passwordValidation.minLength"
          >
            <ng-icon
              hlm
              [name]="passwordValidation.minLength ? 'lucideCheck' : 'lucideX'"
              size="sm"
            />
            <span>Almeno 8 caratteri</span>
          </div>
          <div
            class="flex items-center gap-2"
            [class.text-green-600]="passwordValidation.uppercase"
            [class.text-muted-foreground]="!passwordValidation.uppercase"
          >
            <ng-icon
              hlm
              [name]="passwordValidation.uppercase ? 'lucideCheck' : 'lucideX'"
              size="sm"
            />
            <span>Una lettera maiuscola</span>
          </div>
          <div
            class="flex items-center gap-2"
            [class.text-green-600]="passwordValidation.lowercase"
            [class.text-muted-foreground]="!passwordValidation.lowercase"
          >
            <ng-icon
              hlm
              [name]="passwordValidation.lowercase ? 'lucideCheck' : 'lucideX'"
              size="sm"
            />
            <span>Una lettera minuscola</span>
          </div>
          <div
            class="flex items-center gap-2"
            [class.text-green-600]="passwordValidation.number"
            [class.text-muted-foreground]="!passwordValidation.number"
          >
            <ng-icon
              hlm
              [name]="passwordValidation.number ? 'lucideCheck' : 'lucideX'"
              size="sm"
            />
            <span>Un numero</span>
          </div>
          <div
            class="flex items-center gap-2"
            [class.text-green-600]="passwordValidation.specialChar"
            [class.text-muted-foreground]="!passwordValidation.specialChar"
          >
            <ng-icon
              hlm
              [name]="
                passwordValidation.specialChar ? 'lucideCheck' : 'lucideX'
              "
              size="sm"
            />
            <span>Un carattere speciale (!&#64;#$%...)</span>
          </div>
          @if (forgotPasswordForm.get("confirmPassword")?.value) {
            <div
              class="flex items-center gap-2 mt-2"
              [class.text-green-600]="passwordsMatch"
              [class.text-destructive]="!passwordsMatch"
            >
              <ng-icon
                hlm
                [name]="passwordsMatch ? 'lucideCheck' : 'lucideX'"
                size="sm"
              />
              <span>Le password coincidono</span>
            </div>
          }
        </div>

        <button hlmBtn [disabled]="isLoading()" class="mt-4 w-full">
          @if (isLoading()) {
            <hlm-spinner class="mr-2" />
          }
          Conferma nuova password
        </button>

        <button
          hlmBtn
          variant="link"
          class="w-full"
          [disabled]="isLoading()"
          (click)="onBackToEmail()"
          type="button"
        >
          Torna indietro
        </button>

        <button
          hlmBtn
          variant="link"
          class="w-full"
          [disabled]="isLoading()"
          (click)="onSignInClick()"
          type="button"
        >
          Torna al login
        </button>
      </form>
    } @else if (forgotPasswordState() === forgotPasswordEnum.SUCCESS) {
      <button
        hlmBtn
        variant="link"
        class="mt-4 w-full"
        [disabled]="isLoading()"
        (click)="onSignInClick()"
        type="button"
      >
        Torna al login
      </button>
    }
  </div>
</div>
